export const MIN_PLAYERS = 2
export const MAX_PLAYERS = 8

// these default names are well-suited for multiplayer
export const jokeNames: Readonly<Array<string>> = ['Anon', 'Player', 'Bojangler', 'Courage']
